import React, { Component } from "react";

//views
import CariAppFormViewPg0 from "../presentational/CariAppFormViewPg0";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../../functions/generic_functions";

//router
import { 
    withRouter,
} from 'react-router-dom';

//static routes
import {
    cari_api_create_application_url,
    cari_api_load_form_page_0_url,
    cari_app_form_pg_1_url,
    cari_app_form_pg_3_url,
    cari_home_pg_url,
} from "../../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariFormActiveApplicationData,
    openCariModal,
    resetCariActiveData,
} from "../../../../../redux/actions/indexActions";

//redux mappers
const mapStateToProps = state => {
    return {
        activePositionData: state.cariReducer.activePositionData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
    };
};

/*
    props 
        match => from history of routing
*/

class CariAppFormContainerPg0 extends Component {

    state = {
        mounted: false,
        pageLoaded: false,

        page_num: 0,

        staticUiData: {
            area: "area",
            late_app_deadline: "",
            initial_deadline: "",
            requiredDocuments: [],
            intro_page_general_notes_text: "",
            retention_of_records_text: "",
            privacy_statement_text: "",
            content_consent_checkbox_text: "",
            policies_and_procedures_consent_checkbox_text: "",
            privacy_aggreement_checkbox_text: "",
        },

        postData: {
            position_id: null,
            email: "",
            privacy_aggreement_checkbox_val: false,
            content_consent_checkbox_val: false,
            policies_and_procedures_consent_checkbox_val: false,
        },
    }

    constructor(props) {
        super(props);
 
        //helper functions
        this.uncheckAllConsentBoxes = this.uncheckAllConsentBoxes.bind(this);
        this.getActivePositionDataFromStore = this.getActivePositionDataFromStore.bind(this);

        //load page data from api
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);

        //handlers for action
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);
        this.handleOnClickCreateApplication = this.handleOnClickCreateApplication.bind(this);
    }


    //get active position data from redux store
    getActivePositionDataFromStore() {
        var copyPositionData = this.props.activePositionData;

        if (!isEmpty(copyPositionData)) {
            return copyPositionData;
        }
        else {
            return { "position_id": null, "position_title": "Position Title" }
        }
    }

    /*
        post parameters {
            email,
            token //TODO remove after
            position_id,
            
        }
    
        return data {
            status => true/false,
            message {
                application_status: "", //values can be: "initial", "completed", or null by default(meaning not created yet)
                applicationId: null by default
                staticUiData: {
                    area: "",
                    initial_deadline: "",
                    late_app_deadline: "",
                    requiredDocuments: [
                        "CV",
                        "Cover Letter",
                        "References",
                        "Teaching Dossier",
                        "Publications"
                    ],
                    retention_of_records_text: "",
                    privacy_statement_text: "",
                    intro_page_general_notes_text: "",
                    content_consent_checkbox_text: "",
                    policies_and_procedures_consent_checkbox_text: "",
                }
            }
        }
    */
    load_page_data_from_api() {

        //add email and position_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentPositionId = this.props.activePositionData.position_id;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("position_id", currentPositionId);
        form_data.append("token", currentToken);

        //fetch page data from parameters
        fetch(cari_api_load_form_page_0_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }   
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "User Session is invalid or has expired, please login again.",
                    //     callBackFuncOnOk: () => {
                    //         this.props.resetCariActiveData();
                    //     }
                    // });
                }
            }
        }).then(json => {
            //check if the passed in data for staticUiData is not empty
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message)) 
                && !isEmpty(JSON.parse(json.message).staticUiData)
            ) {
                var json_data = JSON.parse(json.message);
                var fetchedPageData = json_data;

                //grab the status of the application
                var fetchedAppStatus = null;
                if (fetchedPageData.application_status !== undefined && fetchedPageData.application_status !== "") {
                    fetchedAppStatus = fetchedPageData.application_status;
                }

                //grab staticUidata from fetched page data json
                var copyStaticUiData = cloneObject(this.state.staticUiData);

                var fetchedStaticUiData = fetchedPageData.staticUiData;

                //check if the application has been created:
                if (fetchedAppStatus !== null) {

                    var cari_form_url = null;

                    //if it is empty, send api call to create the application 
                    if (!isEmpty(fetchedAppStatus)) {

                        var invalidStatus = false;

                        //if app status is not null and it is in the state of initial(created), redirect to page 1 of the application form or to page 3 if complete
                        if (fetchedAppStatus === "initial" || fetchedAppStatus === "Initial") {
                            //redirect to the first page of the application
                            cari_form_url = cari_app_form_pg_1_url;
                        }
                        else if (fetchedAppStatus === "complete" || fetchedAppStatus === "Complete") {
                            //redirect to the 3rd page of the application
                            cari_form_url = cari_app_form_pg_3_url;
                        }
                        //invalid status, redirect to home
                        else {
                            invalidStatus = true;
                            this.props.openCariModal({
                                modalId: "errorModal",
                                title: "Failed to load valid application status.",
                                callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                            });
                            return;
                        }

                        if (!invalidStatus) {
                            //grab application id data from load
                            let application_id = fetchedPageData.applicationId;

                            let application_status = fetchedPageData.application_status;

                            //store new application id to redux store
                            this.props.setCariFormActiveApplicationData({ "application_id": application_id, "application_status": application_status });

                            //redirect to page 1 of cari form
                            this.props.history.push(cari_form_url);
                        }
                    }
                }
                //application has not been created
                else {
                    //loop through fetched page data and set the state values if they are not null, empty string or undefined
                    for (let stateKey in copyStaticUiData) {
                        let currFetchedVal = fetchedStaticUiData[stateKey];
                        if (!isEmpty(currFetchedVal)) {
                            copyStaticUiData[stateKey] = currFetchedVal;
                        }
                    }

                    //set page loaded to true
                    this.setState({
                        pageLoaded: true,
                        staticUiData: copyStaticUiData,
                    })
                }
            }
            //if no data is found from api, open error modal message
            else {
                // this.props.openCariModal({
                //     modalId: "errorModal",
                //     title: "Failed to retrieve data. ",
                //     callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                // });
            }
        })
        .catch((error) => {
            console.log(error);
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Something went wrong!",
                callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
            });
        })
    }


    componentDidMount() {
        this.setState({
            mounted: true
        }, () => {
            this.load_page_data_from_api();
        })
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    //creates application on submit click
    /*
        post parameters {
            email,
            token //TODO remove after
            position_id,
        }

        return data {
            status => true/false,
            message {
                application_id,
                application_status
            }
        }
    */
    handleOnClickCreateApplication() {
     
        //add email and position_id to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentPositionId = this.props.activePositionData.position_id;
        var currentToken = this.props.activeVerifiedLoginUserData.token;

        var copyPostData = cloneObject(this.state.postData);

        //send api request to create an application for this position_id and current user email
        var form_data = new FormData();
        //add post data to the form
        for(var postDataKey in copyPostData) {
            form_data.append(postDataKey, copyPostData[postDataKey]);
        }
        form_data.append("email", currentEmail);
        form_data.append("position_id", currentPositionId);
        form_data.append("token", currentToken);

        //fetch page data from parameters
        fetch(cari_api_create_application_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message))
            ) {
                var json_data = JSON.parse(json.message);

                var new_application_id = json_data.application_id;
                var new_application_status = json_data.application_status;

                //store new application id to redux store
                this.props.setCariFormActiveApplicationData({ "application_id": new_application_id, "application_status": new_application_status});

                //redirect to page 1
                this.props.history.push(cari_app_form_pg_1_url)
            }
            //if api returns no data, popup modal 
            else {
                // this.props.openCariModal({
                //     modalId: "errorModal",
                //     title: "Failed to create the application.",
                //     callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                // });
            }
        })
        //if api is not found
        .catch((error) => {
            console.log(error);
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Something went wrong!",
                callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
            });
        });
    }

    //unchecks all consent boxses
    uncheckAllConsentBoxes() {
        var copyPostData = cloneObject(this.state.postData);
        copyPostData.privacy_aggreement_checkbox_val = false;
        copyPostData.content_consent_checkbox_val = false;
        copyPostData.policies_and_procedures_consent_checkbox_val = false;
        this.setState({
            postData: copyPostData
        });
    }

    //handles on change events for setting states for form input for post data
    handleOnChangeSetParentState(value, nameKey) {
        var copyPostData = cloneObject(this.state.postData);

        //set the checkbox data
        if (!isEmpty(copyPostData[nameKey])) {
            copyPostData[nameKey] = value;
        }

        //set data
        this.setState({
            postData: copyPostData,
        });
    }

    //close modal and wipe out modal data
    handleOnHideErrorModal() {
        var errorModalDataCopy =  cloneObject(this.state.errorModalData);
        
        errorModalDataCopy.visibleModal = false;
        errorModalDataCopy.errorModalMsg = "";
        errorModalDataCopy.errorModalTitle = "";

        //redirect back to home page 
        this.props.history.push(cari_home_pg_url);
    }

    render() {
        return (
            <div>
                <CariAppFormViewPg0
                    pageLoaded={this.state.pageLoaded}
                    staticUiData={this.state.staticUiData}
                    postData={this.state.postData}
                    onClickCreateApplication={this.handleOnClickCreateApplication}
                    onChangeSetParentState={this.handleOnChangeSetParentState}
                    positionData={this.getActivePositionDataFromStore()}
                    errorModalData={this.state.errorModalData}
                    onHideErrorModal={this.handleOnHideErrorModal}
                />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormContainerPg0));